import { ReportConfig } from '@core/interfaces/report-config.interface';

export const DEFAULT_REPORT_CONFIG: ReportConfig = {
  attachmentPolicy: {
    maxCount: 5,
    maxSizeBytes: 500 * 1024,
    acceptedMimeTypes: ['image/png', 'image/jpeg', 'application/pdf'],
  },
  descriptionMaxLength: 300,
};

export const MEDIA_HEADER = 'Media';
export const MEDIA_VALUE = '003';
